
import { Component, HostListener, OnInit } from '@angular/core';
import { Http, RequestOptions } from '@angular/http';
import { ActivatedRoute, NavigationEnd, Route, Router } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import { environment } from '../../environments/environment';
import { AnalyticsService } from '../analytics/analytics.service';
import { Gift } from '../gift/gift';
import { Registry } from '../registry/registry';
import { RegistryFirebaseService } from '../registry/registry-firebase.service';
import { RegistryService } from '../registry/registry.service';
import { ImageUrlService } from '../shared/services/image-url.service';
import { ToastType } from '../toast/toast.enum';
import { StarterRegistry, TemplateGift } from './starter-registry';
const sampleGifts = require('./sample-gifts.json');
const destinationGifts = require('./destination-gifts.json');
@Component({
  selector: 'app-templates',
  templateUrl: './templates.component.html',
  styleUrls: ['./templates.component.scss']
})
export class TemplateComponent implements OnInit {
  starterRegistries: StarterRegistry[];
  mode = 'gift'
  currentTag = "";
  hideSelectAll = false;
  displayMode = 'categories'
  giftCoun
  t = 0;
  registryGifts: Gift[];
  giftsToAddQueue: TemplateGift[] = new Array<TemplateGift>();
  destinationGifts: TemplateGift[];
  masterGiftTemplates: TemplateGift[];
  searchResults: TemplateGift[];
  collectionGifts: TemplateGift[];
  reccomendedTemplates: TemplateGift[];
  currentStarterRegistry: StarterRegistry;
  registry: Registry;
  searchQuery: string;
  anonymousCoupleMode = false;
  selectedCollection = null;
  destinationCountry = null;
  sectionName = "";
  noResults = false;
  hideDestinationBanner = false;
  hideCollectionsBanner = false;
  scrollPoint = 0;
  giftToAddCount: number;
  private ngUnsubscribe: Subject<void> = new Subject();

  modelChanged: Subject<string> = new Subject<string>();
  scrolled = false;
  stopwords = ['a', 'i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', 'your', 'yours', 'yourself', 'yourselves', 'he', 'him', 'his', 'himself', 'she', 'her', 'hers', 'herself', 'it', 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 'who', 'whom', 'this', 'that', 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 'very', 's', 't', 'can', 'will', 'just', 'don', 'should', 'now']

  destinationList = ["Maldives", "Hawaii", "Bali", "Bora Bora", "The Bahamas", "St. Barts", "Fiji", "St. Lucia", "Greece", "Paris", "Caribbean", "Tokyo", "Thailand", "Australia", "Amalfi Coast", "Santorini", "Sydney", "Melbourne", "Brisbane", "Spain", "Majorca", "Ibiza", "San Sebastian", "Cinque Terre", "Osaka", "Kyoto", "Jamaica", "Cancun", "Tulum", "Playa del Carmen", "Los Cabos", "Aruba", "New Zealand", "Canada", "Mauritius", "Turks & Caicos", "British Virgin Islands", "London", "Greenland", "Iceland", "Ireland", "Scotland", "Tuscany", "Florence", "Seychelles", "Portugal", "Rome", "Costa Rica", "California", "Finland", "Vienna", "St. Kitts", "South Africa", "Dubai", "The Galapagos", "Morocco", "Norway", "Sweden", "Sri Lanka", "Vietnam"]



  collections = [
    { displayName: "Earth Whisperers", collectionTag: "earth-whisperers", imageUrl: "https://images.unsplash.com/photo-1496686941088-eaa405ad5fbb" },
    { displayName: "Wanderlusters", collectionTag: "wanderlusters", imageUrl: "https://images.unsplash.com/photo-1496686941088-eaa405ad5fbb" },
    { displayName: "Sea Nomads", collectionTag: "seanomads", imageUrl: "https://images.unsplash.com/photo-1496686941088-eaa405ad5fbb" },
  ]

  destinationRegistries = [{
    country: "",
    starterRegistry: new StarterRegistry()
  }];
  searchResultsDestinations = [{
    country: "",
    starterRegistry: new StarterRegistry()
  }];
  hideBanner: boolean;
  hideCategoriesBanner: boolean = false;
  @HostListener('window:scroll', ['$event'])
  onWindowScroll($event) {
    //  console.log($event)

    // if ($event && $event.path && $event.path.length > 0) {
    //   ;
    //   this.scrollPoint = $event.path[1].scrollY;

    // }

    if (window.scrollY > 0) {
      this.scrolled = true;
    } else {
      this.scrolled = false;
    }

  }
  constructor(
    private http: Http,
    private registryService: RegistryService,
    private registryFirebaseService: RegistryFirebaseService,
    private route: ActivatedRoute,
    private router: Router,
    private analyticsService: AnalyticsService,
    private imageUrlService: ImageUrlService


  ) {
    this.modelChanged
      .debounceTime(1000) // wait 300ms after the last event before emitting last event
      .distinctUntilChanged() // only emit if value is different from previous value
      .subscribe(searchQuery => {

        this.analyticsService.trackEvent("Templates Searched", { search_term: searchQuery, display_mode: this.displayMode });

      });

    window.scrollTo(0, 0);
    this.scrolled = false;
    const searchBox = document.getElementById('template-search');
    if (searchBox) {
      searchBox.focus()
    }


    //   this.router.events.takeUntil(this.ngUnsubscribe).subscribe((event) => {

    //     if (event instanceof NavigationEnd && 
    //       (event.url.toLowerCase() === '/registry/templates' || 
    //       event.url.toLowerCase() === '/create-registry')) {

    //       if (localStorage.getItem('skip-templates-banner')){
    //         this.hideBanner = true;
    //       } else {
    //         this.hideBanner = false;;
    //       }
    //     }
    //   });



  }
  toTitleCase(str) {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }


  goTocollection(collection: any) {
    ;
    this.displayMode = 'collection_detail';
    this.selectedCollection = this.toTitleCase(collection.displayName);
    window.scrollTo(0, 0);
    this.collectionGifts = this.masterGiftTemplates.filter(x => x.collection && x.collection.includes(collection.collectionTag))
    this.setGiftsAsAdded(this.collectionGifts);

  }
  goToCountryGifts(country: string) {
    this.hideSelectAll = false;
    this.displayMode = 'destination_country';
    this.destinationCountry = this.toTitleCase(country);
    window.scrollTo(0, 0);
    this.destinationGifts = this.registryService.getCountryStarterGifts(country);

    this.setGiftsAsAdded(this.destinationGifts);
    const availableGifts = this.destinationGifts.filter(gift => !gift.isAdded);
    if (availableGifts && availableGifts.length <= 1) {
      this.hideSelectAll = true;
    }
    this.analyticsService.trackEvent("Templates - Destination country selected", { country: country });
  }

  setGiftsAsAdded(gifts: TemplateGift[]) {

    if (this.registryGifts) {
      gifts.forEach(gift => {

        let giftMatch = this.registryGifts.filter(x => x.templateGiftId == gift.id);

        if (giftMatch && giftMatch.length) {
          gift.isAdded = true;
        }
      })
    }

  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  initialiseTemapltes() {
    if (this.masterGiftTemplates && this.masterGiftTemplates.length) {
      this.masterGiftTemplates = this.masterGiftTemplates.sort((a, b) => a.title.localeCompare(b.title));

      this.masterGiftTemplates = this.masterGiftTemplates.filter(x => x.title != 'OURS Premarital Experience')

      this.searchResults = this.masterGiftTemplates


      this.getReccomendedTemplates();
      this.filterTags("");
    }
  }

  goToRegistry() {
    if (this.anonymousCoupleMode) {
      this.router.navigate(['your-registry'])
    } else {
      this.router.navigate(['registry'])
    }
  }

  goToCreateCustomGift() {
    if (this.anonymousCoupleMode) {
      this.router.navigate(['create-custom-gift'])
    } else {
      if (this.sectionName) {
        this.router.navigate(['registry', 'create-gift', this.sectionName])
      } else {
        this.router.navigate(['registry', 'create-gift'])
      }
    }
  }


  extractFirstThreeGiftImagesForRegistry(starterRegisties: StarterRegistry[]) {





    starterRegisties.forEach(starterRegistry => {
      if (!starterRegistry.gifts || !starterRegistry.gifts.length) {
        return;
      }
      let images = [];
      let count = 0;
      starterRegistry.gifts.forEach(gift => {

        if (gift.imageUrl && count < 3) {
          images.push(gift.imageUrl);
          count = count + 1;
        }
      })
      let countr = starterRegistry.country;
      starterRegistry.image1Url = images[0];
      starterRegistry.image2Url = images[1];
      starterRegistry.image3Url = images[2];
    })

  }


  buildDestinationRegistries() {
    // this.destinationList = this.destinationList.filter(x=>!x)
    this.removeDestinationsThatDontHaveGifts();
    this.destinationRegistries = new Array<{ country: string, starterRegistry: StarterRegistry }>();
    this.destinationList.forEach(destination => {
      let result: any = this.starterRegistries.filter(x => x.country == destination && x.country.length)
      if (!result) {
        console.error("no registry for " + destination)
      }
      if (result[0] && result[0].gifts && result[0].gifts.length) {
        this.destinationRegistries.push({
          country: destination,
          starterRegistry: result[0]
        })
      }


    });
    //this.destinationRegistries = this.destinationRegistries.filter(x=>!x.country);
    this.searchResultsDestinations = this.destinationRegistries;
  }


  removeDestinationsThatDontHaveGifts() {
    this.destinationList = this.destinationList.filter(destination => {
      let result: any = this.starterRegistries.filter(x => x.country == destination && x.country.length && x.gifts && x.gifts.length)
      if (!result) {
        return false;
      }
      return true;
    });
  }


  ngOnInit(): void {

    this.registry = this.route.snapshot.data.registry;
    let starterRegistryString = localStorage.getItem('starter-registries');
    if (!starterRegistryString) {
      starterRegistryString = JSON.stringify(destinationGifts);
    }

    this.registryFirebaseService.currentRegGifts(this.registry.id).subscribe(x => {
      //required for gifts
    })
    this.registryFirebaseService.regforUser().subscribe(reg => {
      this.registry = reg;
    });

    this.starterRegistries = JSON.parse(starterRegistryString);

    this.extractFirstThreeGiftImagesForRegistry(this.starterRegistries);
    this.buildDestinationRegistries();
    this.route.paramMap.subscribe(params => {
      this.sectionName = params.get('sectionName');
      if (this.sectionName == "destinations") {
        this.displayMode = "destination";
      }

    });

    const pageUserMode = this.route.snapshot.data.pageUserMode;



    let destinationStorageHideValue = localStorage.getItem("hide-destination-banner");
    if (destinationStorageHideValue) {
      this.hideDestinationBanner = true;
    }
    let categoriesStorageHideValue = localStorage.getItem("hide-categories-banner");
    if (categoriesStorageHideValue) {
      this.hideCategoriesBanner = true;
    }
    let collectionsStorageValue = localStorage.getItem("hide-collections-banner");
    if (collectionsStorageValue) {
      this.hideCollectionsBanner = true;
    }
    if (pageUserMode == 'couple_anon') {
      this.anonymousCoupleMode = true;
      this.registryFirebaseService.killLoader();
    }

    if (starterRegistryString) {
      this.registryService.getStarterRegistryTemplates();
    }

    this.loadMasterTemplatesFromLocalStorageOrGetViaApi();

    if (!this.anonymousCoupleMode) {
      this.registryFirebaseService.getGiftsforRegistry(this.registry.id).subscribe(gifts => {
        this.checkIfTemplateHasBeenAdded(gifts);

      }


      )

    } else {

      let localGifts = this.registryFirebaseService.getLocalGifts();

      this.checkIfTemplateHasBeenAdded(localGifts);
    }
  }

  private loadMasterTemplatesFromLocalStorageOrGetViaApi() {
    let masterGiftTemplateString = localStorage.getItem('template-gifts');
    if (!masterGiftTemplateString) {

      masterGiftTemplateString = JSON.stringify(sampleGifts);
      this.masterGiftTemplates = JSON.parse(masterGiftTemplateString);
      this.searchResults = this.masterGiftTemplates
      this.registryService.getGiftTemplates().then(templates => {
        this.masterGiftTemplates = templates;


        this.initialiseTemapltes();

        this.getReccomendedTemplates();
        this.checkIfTemplateHasBeenAdded(this.registryGifts);
      });
    } else {
      this.masterGiftTemplates = JSON.parse(masterGiftTemplateString);
      this.getReccomendedTemplates();
      this.initialiseTemapltes();
    }


  }

  checkIfTemplateHasBeenAdded(gifts: Gift[]) {
    this.registryGifts = gifts;

    if (gifts && gifts.length) {
      localStorage.setItem('skip-templates-banner', 'true');
    }
    if (this.currentStarterRegistry) {
      this.setAsAddedIfInRegistry(this.currentStarterRegistry.gifts);
    }
    if (this.masterGiftTemplates) {
      this.setAsAddedIfInRegistry(this.masterGiftTemplates);
    }
    if (this.reccomendedTemplates) {
      this.setAsAddedIfInRegistry(this.reccomendedTemplates);
    }
  }

  toggleVideo(e: Event, videoImage: Gift) {

    e.stopImmediatePropagation();
    var videobuttons: any = document.getElementsByClassName('video_button');

    var videos: any = document.getElementsByClassName('pexels_video');
    var pausebuttons: any = document.getElementsByClassName('paused');

    if (videobuttons) {
      Array.from(videobuttons).forEach(element => {
        (element as any).style.display = "none";

      });
    }
    if (pausebuttons) {
      Array.from(pausebuttons).forEach(element => {
        (element as any).style.display = "none";

      });
    }







    var videoPlayer: any = document.getElementById(videoImage.videoUrl);

    var addButton: any = document.getElementById(videoImage.videoUrl + '_add');
    var currentPausebutton: any = document.getElementById(videoImage.videoUrl + '_pause_button');
    var currentPlayButton: any = document.getElementById(videoImage.videoUrl + '_play_button');
    if (videoPlayer.paused) {
      if (videos) {
        Array.from(videos).forEach(element => {

          (element as any).pause();
          //  (element as any).classList.add("paused");
        });
      }

      videoPlayer.play();

      if (currentPausebutton) {
        (currentPausebutton as any).style.display = "block";
      }
      if (currentPlayButton) {
        (currentPlayButton as any).style.display = "none";
      }
      if (addButton) {
        (addButton as any).style.display = "block";
      }

    }
    else {
      videoPlayer.pause();
      if (currentPausebutton) {
        (currentPausebutton as any).style.display = "none";
      }
      if (currentPlayButton) {
        (currentPlayButton as any).style.display = "block";
      }
      if (addButton) {
        (addButton as any).style.display = "none";
      }

    }
    // videoPlayer.classList.add("playing");


  }

  getReccomendedTemplates() {
    this.reccomendedTemplates = this.registryFirebaseService.getHitchdReccomendedTemplates(this.registryGifts, this.registry)
  }

  search(arg) {
    this.modelChanged.next(arg);
    if (this.displayMode == "categories") {
      this.filterGifts(arg);
    } else if (this.displayMode == "destination") {
      this.filterDestinations(arg)
    }
  }
  removeFromGiftQueue(gift: TemplateGift) {
    gift.toBeAdded = false;
    this.giftToAddCount = this.giftToAddCount - 1;
  }
  addToGiftQueue(gift: TemplateGift) {
    gift.toBeAdded = true;
    this.giftToAddCount = this.giftToAddCount + 1;
  }

  removeStopWords(words: string[]) {

    words = words.filter((el) => !this.stopwords.includes(el.toLowerCase()));
    return words;
  }

  test(arr, sub) {

    sub = sub.toLowerCase();
    let results = arr.map(str => str
      .toLowerCase()
      .startsWith(sub.slice(0, Math.max(str.length - 1, 1)))
    );
    return (results.includes(true));
  }

  forceAlphaAndReturnArray(text: string) {
    let wordArray = text.split(" ");
    return wordArray;
    // return wordArray.filter(word=> word.replace(/[^0-9a-z]/gi, ''))

  }

  filterTags(tag: string) {


    this.currentTag = tag;

    if (!tag) {
      this.searchResults = this.reccomendedTemplates.concat(this.masterGiftTemplates);
    } else if (tag == 'essentials') {
      this.searchResults = this.reccomendedTemplates;
    }
    else {
      this.searchResults = this.masterGiftTemplates.filter(x => x.tags && x.tags.includes(tag));
    }
  }

  filterDestinations(searchQuery) {
    this.noResults = false;;
    if (!searchQuery || searchQuery.length <= 1) {
      this.searchResultsDestinations = this.destinationRegistries;
      return;
    }
    this.searchQuery = this.searchQuery.toLowerCase();
    this.searchResultsDestinations = [];
    this.searchResultsDestinations = this.destinationRegistries.filter(destination => destination.country.toLowerCase().includes(searchQuery.toLowerCase()));

    if (!this.searchResultsDestinations || !this.searchResultsDestinations.length) {
      this.noResults = true;
    }


  }







  filterGifts(searchQuery) {

    this.noResults = true;
    if (!searchQuery || searchQuery.length <= 2) {
      this.searchResults = this.masterGiftTemplates;
      return;
    }
    else {

      this.searchQuery = this.searchQuery.toLowerCase();
      this.searchResults = [];


      this.masterGiftTemplates.forEach(e => {

        let points = 0;

        if (e.title && this.test(this.removeStopWords(this.forceAlphaAndReturnArray(e.title)), searchQuery)) {
          points = points + 10
        }
        if (e.description && this.test(this.removeStopWords(this.forceAlphaAndReturnArray(e.description)), searchQuery)) {
          points = points + 5
        }
        if (e.tags && this.test(e.tags, searchQuery)) {
          points = points + 2;
        }

        if (points) {
          e.points = points;
          this.searchResults.push(e)
          this.noResults = false;
        }
        if (this.searchResults) {
          this.searchResults = this.searchResults.sort((a, b) => b.points - a.points);
        }

      })


    }

  }


  pullGiftsFrom(registryName: string) {
    if (this.starterRegistries && this.starterRegistries.length) {

      this.currentStarterRegistry = this.starterRegistries.filter(x => x.registryName == registryName)[0];
      if (!this.currentStarterRegistry) {
        console.log("NO REGISTRY FOUND WITH NAME" + registryName)
        return;
      }
      this.mode = "registry-gifts";
      this.setAsAddedIfInRegistry(this.currentStarterRegistry.gifts);

      this.currentStarterRegistry.gifts.forEach(gift => {
        if (!gift.isAdded) {
          gift.toBeAdded = true;
        }
      })

      this.giftToAddCount = this.currentStarterRegistry.gifts.filter(x => x.toBeAdded).length;



    }


  }

  AddGiftQueueToRegistry() {
    this.currentStarterRegistry.gifts.filter(x => x.toBeAdded).forEach((gift) => {
      this.addGiftToRegistry(gift);
    })
    this.router.navigate(['/registry'])
  }

  setAsAddedIfInRegistry(gifts: TemplateGift[]) {


    if (!this.registryGifts) {
      return;
    }
    gifts.filter((gift => {
      gift.isAdded = false;
    }))

    this.registryGifts.filter(x => x.fromTemplate).forEach(registryGift => {

      let giftMatch = gifts.filter(x => x.id == registryGift.templateGiftId);
      if (giftMatch && giftMatch.length) {

        giftMatch[0].isAdded = true;

        let matches = this.registryGifts.filter(x => x.templateGiftId == giftMatch[0].id);
        if (matches) {
          giftMatch[0].addedCount = matches.length;
        }
      }

    });

    // let giftMatch =this.registryGifts.filter(x=>x.templateGiftId == gift.id);
    // if(giftMatch && giftMatch.length){
    //   return true;
    // }
    // return false;
  }

  getGiftUrlWithoutHex(gift: Gift) {
    if (gift && gift.imageUrl) {
      return this.imageUrlService.getStandardImageUrl(gift.imageUrl);
    }
    else {
      return ""
    }
  }
  color(gift: Gift) {
    return this.registryService.getColor(gift.imageUrl);
  }

  getDestinationImageUrl(imageUrl: string): string {
    return this.imageUrlService.getStandardImageUrl(imageUrl);
  }

  getCollectionImageUrl(imageUrl: string): string {
    return this.imageUrlService.getStandardImageUrl(imageUrl);
  }
  editGiftTemplate(gift: Gift) {

  }

  cleanTitleString(title) {

    const ranges = [
      '[\u00A0-\u269f]',
      '[\u26A0-\u329f]',
      // The following characters could not be minified correctly
      // if specifed with the ES6 syntax \u{1F400}
      '[🀄-🧀]',
      '[\u{1F004}-\u{1F9C0}]'
    ];

    return title.replace(new RegExp(ranges.join('|'), 'ug'), '').replace(/[^\w\s]/gi, '').replace(/ /g, '-');


  }

  editTemplate(gift: TemplateGift) {
    let fromSource = "search-results";
    // gift.isAdded = true;
    if (this.currentStarterRegistry) {
      fromSource = this.currentStarterRegistry.registryName;
    }
    gift.fromRegistry = fromSource
    gift.templateGiftId = gift.id;
    gift.fromTemplate = true;
    gift.friendlyUrl = this.cleanTitleString(gift.title)

    if (this.anonymousCoupleMode) {
      this.router.navigateByUrl('/your-registry/' + gift.friendlyUrl + "/edit?giftTemplateId=" + gift.id + "&isDuplicate=1")
      return
    } else {
      this.router.navigateByUrl('/registry/' + gift.friendlyUrl + "/edit?giftTemplateId=" + gift.id + "&isDuplicate=1")
    }


  }

  addGiftToRegistryLocally(templateGift: TemplateGift) {

    let gift: Gift = this.prepGiftForAdding(templateGift);
    const templateId = gift.id;
    gift.fromRegistry = "search-results"
    //gift.templateGiftId = templateId;
    gift.fromTemplate = true;
    // gift.id = null;
    this.registryFirebaseService.addGiftLocally(gift);
    this.giftToAddCount = this.giftToAddCount + 1;
    this.checkIfTemplateHasBeenAdded(this.registryFirebaseService.getLocalGifts());

  }



  prepGiftForAdding(templateGift: TemplateGift, fromSource = "search-results"): Gift {
    let gift: Gift = JSON.parse(JSON.stringify(templateGift));
    templateGift.isAdded = true;
    if (this.currentStarterRegistry) {
      fromSource = this.currentStarterRegistry.registryName;
    }
    const templateId = gift.id;
    gift.fromRegistry = fromSource
    gift.templateGiftId = templateId;
    gift.fromTemplate = true;
    gift.id = null;
    return gift;
  }


  addGiftToRegistry(templateGift: TemplateGift) {

    if (this.anonymousCoupleMode) {
      this.addGiftToRegistryLocally(templateGift);

      return
    }
    let gift: Gift = this.prepGiftForAdding(templateGift);

    this.registryService.emitToastType(ToastType.createdGift);
    this.registryFirebaseService.addGift(gift, this.registry).then(() => {
      this.addGiftEvent(gift);


      if (this.sectionName && this.sectionName != 'destinations') {

        this.registryFirebaseService.addGiftIdToSection(this.sectionName, this.registry, gift.id);
      }


    });

  }


  addGiftToQueue(templateGift: TemplateGift) {
    templateGift.toBeAdded = true;
    this.giftsToAddQueue.push(templateGift);
    if (this.displayMode == 'destination_country') {
      if (this.giftsToAddQueue.length == this.destinationGifts.length) {
        this.hideSelectAll = true;
      }
    } else if (this.displayMode == 'collection_detail') {
      if (this.giftsToAddQueue.length == this.collectionGifts.length) {
        this.hideSelectAll = true;
      }
    }


  }


  addGiftEvent(gift: Gift) {

    let destinationCountry = null;
    let collection = null;
    let created_from = 'gift_templates';
    if (this.displayMode == 'destination_country') {
      created_from = 'destination_country';
      destinationCountry = this.destinationCountry;
    }
    if (this.displayMode == 'collection_detail') {
      created_from = 'collection';
      collection = this.selectedCollection;
    }

    this.analyticsService.trackEvent('Gift Created', {

      title: gift.title,
      created_from: created_from,
      desitnation_country: this.destinationCountry,
      collection: this.selectedCollection,
      template_id: gift.templateGiftId,
      templateName: gift.title
    });

  }
  hideDestinationBannerInStorage() {
    localStorage.setItem('hide-destination-banner', 'true');
    this.hideDestinationBanner = true;

  }
  hideCollectionsBannerInStorage() {
    localStorage.setItem('hide-collections-banner', 'true');
    this.hideCollectionsBanner = true;

  }

  hideCategoriesBannerLocalStorage() {
    localStorage.setItem('hide-categories-banner', 'true');
    this.hideCategoriesBanner = true;

  }

  duplicateTemplate(gift: TemplateGift) {

    this.registryFirebaseService.duplicateGift(gift, this.registryGifts, this.registry, this.router, true, this.anonymousCoupleMode);

    this.analyticsService.trackEvent("Template duplicated", { title: gift.title });
  }


  removeLocalGift(templateGift: TemplateGift) {

    const templateId = templateGift.id;
    templateGift.fromRegistry = "search-results"
    //gift.templateGiftId = templateId;
    templateGift.fromTemplate = true;
    // gift.id = null;
    this.registryFirebaseService.removeLocalGift(templateGift);
    this.giftToAddCount = this.giftToAddCount - 1;
    this.checkIfTemplateHasBeenAdded(this.registryFirebaseService.getLocalGifts());
  }
  removeGiftFromQueue(templateGift: TemplateGift) {
    templateGift.toBeAdded = false;
    this.giftsToAddQueue = this.giftsToAddQueue.filter(x => x.id != templateGift.id);
    this.hideSelectAll = false;

  }
  selectAllDestinationGifts() {

    this.giftsToAddQueue = new Array<TemplateGift>();
    if (this.displayMode == 'destination_country') {
      this.destinationGifts.forEach(gift => {
        if (!gift.isAdded) {
          this.addGiftToQueue(gift);
        }
      })
    } else if (this.displayMode == 'collection_detail') {
      this.collectionGifts.forEach(gift => {
        if (!gift.isAdded) {
          this.addGiftToQueue(gift);
        }
      })
    }
    this.hideSelectAll = true;

  }

  addDestinationGiftsToRegistry() {

    this.sectionName = this.destinationCountry;
    this.giftsToAddQueue.forEach(gift => {
      this.addGiftToRegistry(gift);

    })
      ;
    this.giftsToAddQueue = new Array<TemplateGift>();
    return this.router.navigate(['/registry'])
  }

  addRemoveGiftToQueue(gift: TemplateGift) {
    if (gift.isAdded) {
      return;
    }
    if (gift.toBeAdded) {
      this.removeGiftFromQueue(gift);
      this.analyticsService.trackEvent("Template removed from queue", { title: gift.title, displayMode: this.displayMode });
    } else {
      this.addGiftToQueue(gift);
      this.analyticsService.trackEvent("Template added into queue", { title: gift.title, displayMode: this.displayMode });
    }

  }

  changeDisplayMode(displayMode: string) {
    this.displayMode = displayMode;
    this.searchQuery = "";
    this.searchResults
    this.giftsToAddQueue = new Array<TemplateGift>();
    this.filterTags("");
    this.filterDestinations("");
    this.hideSelectAll = false;
    this.analyticsService.trackEvent("Templates menu item clicked", { section: displayMode });
  }


  removeGift(templateGift: TemplateGift) {

    if (this.anonymousCoupleMode) {
      this.removeLocalGift(templateGift);
      return
    }
    templateGift.addedCount = templateGift.addedCount - 1;
    let giftToDelete = this.registryGifts.filter(x => x.templateGiftId == templateGift.id)[0];
    if (giftToDelete) {
      this.registryFirebaseService.removeGift(giftToDelete, this.registry)
      templateGift.isAdded = false;

    }

    this.analyticsService.trackEvent("Template removed", { title: templateGift.title });

  }
}




// WEBPACK FOOTER //
// ./src/app/templates/templates.component.ts